module.exports = __webpack_public_path__ + "static/media/mariaDB.c8f71708.svg";